import React, { useState } from 'react';
import AttentionPopup from './AttentionPopup';
import { Button, PrimaryButton } from '../../../common/Buttons';

const TaskUpdateConfirm = ({ closeModal, onSave, status = 'COMPLETE' }) => {
    const [isSaving, setIsSaving] = useState(false);

    const handleSave = async () => {
        setIsSaving(true);
        try {
            await onSave();
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <AttentionPopup closeModal={closeModal}>
            <div className="tasks-copied-message" style={{ fontSize: '15px', padding: '20px' }}>
                You are changing task status to <span style={{ color: "#007bff" }}><b>{status}</b></span>. Once You Click Save, the Task Cannot be Edited Further.
            </div>

            <div className="attention-popup-footer">
                <Button variant="gray" onClick={closeModal} disabled={isSaving}>
                    Close
                </Button>
                &nbsp;&nbsp;
                <PrimaryButton onClick={handleSave} loading={isSaving} disabled={isSaving} loadingText="Loading...">
                    Save
                </PrimaryButton>
            </div>
        </AttentionPopup>
    );
};

export default TaskUpdateConfirm;
